import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, Compass } from "lucide-react";
import { useDocumentMeta } from "../lib/seo";

type NotFoundPageProps = {
  title?: string;
  text?: string;
  backTo?: string;
  backLabel?: string;
};

export function NotFoundPage({
  title = "This page could not be found",
  text = "The link may be old or the page may have moved. You can return home or continue browsing current properties.",
  backTo,
  backLabel
}: NotFoundPageProps) {
  useDocumentMeta({
    title: `${title} | Triple H Myanmar`,
    description: "The requested page is not available. Browse Triple H property listings or contact our team.",
    noindex: true
  });

  return (
    <section className="not-found-page">
      <div className="container not-found-grid">
        <div className="not-found-mark" aria-hidden="true">
          <img src="/brand/logo-mark.png" alt="" width="150" height="146" />
          <span>404</span>
        </div>
        <div className="not-found-copy">
          <span className="eyebrow">Off the map</span>
          <h1>{title}</h1>
          <p>{text}</p>
          <div className="not-found-actions">
            {backTo ? (
              <Link className="btn btn-primary" to={backTo}>
                <ArrowLeft aria-hidden="true" /> {backLabel || "Go back"}
              </Link>
            ) : (
              <Link className="btn btn-primary" to="/">
                <ArrowLeft aria-hidden="true" /> Return home
              </Link>
            )}
            <Link className="btn btn-outline" to="/properties">
              Browse properties <ArrowRight aria-hidden="true" />
            </Link>
          </div>
          <Link className="not-found-contact" to="/contact">
            <Compass aria-hidden="true" /> Not sure where to start? Talk to our team.
          </Link>
        </div>
      </div>
    </section>
  );
}
